import { createSvgIcon } from 'shared/icons/IconUtils';

export const TruckFaceIcon = createSvgIcon(
  'TruckFaceIcon',
  <>
    <rect width="4" height="4" rx="1" transform="matrix(1 0 0 -1 3.6665 22)" />
    <rect width="4" height="4" rx="1" transform="matrix(1 0 0 -1 17.6665 22)" />
    <rect x="5.6665" y="2" width="2" height="2" />
    <rect x="17.6665" y="2" width="2" height="2" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.6665 4H5.6665V13H19.6665V4ZM17.6665 7H7.6665V11H17.6665V7Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.0024 14.4962C3.78338 14.8247 3.6665 15.2107 3.6665 15.6056V20H21.6665V15.6056C21.6665 15.2107 21.5496 14.8247 21.3306 14.4962L19.6665 12H5.6665L4.0024 14.4962ZM10.6665 13C10.1142 13 9.6665 13.4477 9.6665 14V17H15.6665V14C15.6665 13.4477 15.2188 13 14.6665 13H10.6665ZM5.6665 16C5.6665 15.4477 6.11422 15 6.6665 15C7.21879 15 7.6665 15.4477 7.6665 16C7.6665 16.5523 7.21879 17 6.6665 17C6.11422 17 5.6665 16.5523 5.6665 16ZM18.6665 15C18.1142 15 17.6665 15.4477 17.6665 16C17.6665 16.5523 18.1142 17 18.6665 17C19.2188 17 19.6665 16.5523 19.6665 16C19.6665 15.4477 19.2188 15 18.6665 15Z"
    />
  </>,
);
